import { useCallback } from "react";
import useTrackerContext from "../useTrackerContext";
import useGlobalContext from "../useGlobalContext";
import useUserAgent from "../useUserAgent";

const ACTION_NAME = "flights__genius_airlines_banner";
const ACTION_VERSION = "2.0.x";

type GeniusAirlinesBannerContent = {
  airlines: string[];
  platform: string;
  uvi?: string;
  session_id?: string;
  aid?: string;
  channel?: string;
};

export const useGeniusAirlinesBannerEvent = () => {
  const { trackExternal } = useTrackerContext();
  const { isMobile } = useUserAgent();
  const { analyticSessionId, isOfMetaOrigin, marketingTrackingVariables, uvi } = useGlobalContext();

  return useCallback(
    (airlines: string[]) => {
      const trackingData = {
        analyticSessionId,
        isMobile,
        marketingTrackingVariables,
        uvi,
        isOfMetaOrigin
      };

      const content: GeniusAirlinesBannerContent = {
        airlines,
        platform: trackingData.isMobile ? "mdot" : "desktop",
        session_id: trackingData.analyticSessionId || "",
        uvi: trackingData.uvi || "",
        aid: trackingData.marketingTrackingVariables?.aid || "",
        channel: trackingData.isOfMetaOrigin ? "meta" : "direct"
      };

      trackExternal({
        type: "c360",
        args: [
          {
            action_name: ACTION_NAME,
            action_version: ACTION_VERSION,
            content
          }
        ]
      });
    },
    [analyticSessionId, isMobile, marketingTrackingVariables, trackExternal, uvi, isOfMetaOrigin]
  );
};

export default useGeniusAirlinesBannerEvent;
